import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../_redux/student-book-report/StudentBookReportAction";
import * as uiHelpers from "../StandardReportUIHelpers";
import { 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { useStandardReportUIContext } from "../StandardReportUIContext";

export function StandardReportTable() {
  // Standard Report UI Context
  const standardReportUIContext = useStandardReportUIContext();
  const standardReportUIProps = useMemo(() => {
    return {
      queryParams: standardReportUIContext.queryParams,
      setQueryParams: standardReportUIContext.setQueryParams
    };
  }, [standardReportUIContext]);

  // Getting curret state of Standard Report list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentBookReport }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Finished Books Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    if (standardReportUIProps.queryParams.term) dispatch(actions.getStandardReport(standardReportUIProps.queryParams));
    return () => dispatch(actions.cleanStudentBookReportState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [standardReportUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "teacher",
      text: "Öğretmen",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "studentNumber",
      text: "Öğrenci Numarası",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "studentName",
      text: "Adı Soyadı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "bookName",
      text: "Kitap Adı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "pageNumber",
      text: "Sayfa Sayısı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "date",
      text: "Tarih",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: standardReportUIProps.queryParams.pageSize,
    page: standardReportUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                standardReportUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}